import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Router from 'vue-router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import msg from './utils/msg'
import storage from './utils/storage'
import BaiduMap from 'vue-baidu-map'
import request from './utils/request/request'
import VueCookies from 'vue-cookies';
import timeInit from './utils/timeInit'
import Echarts from '@/components/common/Echarts'
import dataV from '@jiaminghi/data-view'
// import './utils/langs/trans.js' //引入语言
import rolePermit from './utils/rolePermit' //权限判断函数
Vue.prototype.rolePermit = rolePermit

import draggable from '@/components/AI/drag'
Vue.directive('draggable', draggable);

import vueSeamlessScroll from 'vue-seamless-scroll'
Vue.use(vueSeamlessScroll)

// // md组件
// import VMdPreview from '@kangc/v-md-editor/lib/preview';
// import '@kangc/v-md-editor/lib/style/preview.css';
// import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
// import '@kangc/v-md-editor/lib/theme/style/github.css';

// // highlightjs
// import hljs from 'highlight.js';

// VMdPreview.use(githubTheme, {
//   Hljs: hljs,
// });

// Vue.use(VMdPreview);
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';

import Prism from 'prismjs';

VueMarkdownEditor.use(vuepressTheme, {
  Prism,
  // config: {
  //   toc: {
  //     includeLevel: [3, 4],
  //   },
  // },
});

Vue.use(VueMarkdownEditor);

import axios from "axios";
//下面是将$axios和$qs挂在原型上，以便在实例中能用 this.$axios能够拿到
Vue.prototype.$axios = axios;

// add by fu-gzh at 2020-12-01 start
import moment from 'moment'; //导入模块
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn');
Vue.prototype.$moment = moment;//赋值使用
// add by fu-gzh at 2020-12-01 end
Vue.use(VueCookies);
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.prototype.request = request
// console.log(process.env)
// console.log(location)
const baseUrlAddr = process.env.VUE_APP_BASE_URL;
// const baseUrlAddr = '/api';
Vue.prototype.baseUrlAddr = baseUrlAddr;
// console.log(process.env);

const websocketUrlAddr = process.env.VUE_APP_WEBSOCKET_URL
// const websocketUrlAddr = '/api2';
Vue.prototype.websocketUrlAddr = websocketUrlAddr;

const adminUrlAddr = process.env.VUE_APP_ADMIN_URL

Vue.prototype.adminUrlAddr = adminUrlAddr;
//商城详情页iconfont
import './assets/shopFont/iconfont.css'
Vue.config.productionTip = false
Vue.use(dataV)
Vue.use(ElementUI)
Vue.use(msg)
Vue.use(timeInit)
Vue.use(storage)
Vue.component('echarts', Echarts)
Vue.config.productionTip = false
Vue.use(BaiduMap, {
  // ak: "jWZW8MNGpwkaPg3QXIuNbbRbH5ygdRcN"
  ak: "XDcTlNcyshIoCLu50z2kHlM0IffYKbKq"
})

Vue.prototype.getViewportSize = function () {
  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  };
}()

// 全局注册，监听localStorge中key值==alarmList的变化
Vue.prototype.resetSetItem = function (key, data, expire) {
  // 创建一个StorageEvent事件
  if (key === 'alarmList') {
    var newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }

    // 设置过期时间
    if (expire) {
      let obj = {
        data,
        time: Date.now(),
        expire: expire * 86_400_000
        // expire: expire * 86400000
      }
      return storage.setItem(key, JSON.stringify(obj))
    }

    return storage.setItem(key, data)
  }
}
Vue.prototype.resetGetItem = function (key) {
  // 创建一个StorageEvent事件
  if (key === 'alarmList') {
    let val = localStorage.getItem(key)

    if (!val) return val
    val = JSON.parse(val)
    if (!val) return val

    if (!val.time) return val

    // 存值时间戳 +  有效时间 = 过期时间戳
    // 如果当前时间戳大于过期时间戳说明过期了，删除值并返回提示
    if (Date.now() > val.time + val.expire) {
      localStorage.removeItem(key)
      return null
    }

    return JSON.parse(val.data)
  }
}

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
